import { render, staticRenderFns } from "./RigInfo.vue?vue&type=template&id=78c33068"
import script from "./RigInfo.vue?vue&type=script&lang=ts"
export * from "./RigInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports